import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import RRBulkEditChargeCategoriesForm from './rr-bulk-edit-charge-categories-form'
import { ReservedResourceF } from '../../../types/reservation-detail.types'

type RRBulkEditChargeCategoriesDrawerProps = {
  propertyId: string
  open: boolean
  onClose: () => void
  reservedResources: ReservedResourceF[]
  reservation: {
    groupName?: string
    start?: Date
    end?: Date
  }
  onSuccess?: () => Promise<void>
}

export default function RRBulkEditChargeCategoriesDrawer(props: RRBulkEditChargeCategoriesDrawerProps) {
  const { propertyId, open, onClose, onSuccess, reservedResources, reservation } = props
  const { lg } = useBreakpoints()

  return (
    <RRBulkEditChargeCategoriesForm
      appearance={{ type: 'DRAWER', open: open, onClose: onClose, width: lg ? '70%' : '100%' }}
      propertyId={propertyId}
      reservedResources={reservedResources}
      onBack={onClose}
      onSuccess={onSuccess}
      reservation={reservation}
    />
  )
}
